import Gdpr from '@/components/l_gdpr/gdpr'

export default {
    path: '/gdpr',
    name: 'Gdpr',
    component: Gdpr,
    beforeEnter: (to, from, next) => {
        next();
    }
}


// WEBPACK FOOTER //
// ./src/router/Gdpr.router.js